import { Routes } from '@angular/router';
import { ProfilsComponent } from './profils.component';

export const PROFILS_ROUTES: Routes = [
    {
        path: '',
        component: ProfilsComponent,
        data: {
            role: 'ADMIN',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.administration-profils',
                icon: 'key'
            }
        }
    }
];
